import type { BrannanWebsiteHeaderSettings } from '@shared/types/WebsiteHeaderSettings.types';
import React from 'react';
import type { HeaderV2Props } from '../HeaderV2';
import { HeaderV2 } from '../HeaderV2';
import { Header } from '../Header';
import { HeaderPreloader } from '../HeaderV2/HeaderPreloader';

export interface WebsiteHeaderProps extends Omit<HeaderV2Props, 'websiteHeader'> {
  websiteHeader: Maybe<BrannanWebsiteHeaderSettings['websiteHeader']>;
  pageId?: string;
  eventDisplayName: Maybe<string>;
}

const WebsiteHeader = ({ eventDisplayName, pageId, websiteHeader, masthead, ...restProps }: WebsiteHeaderProps) => {
  // The V2 set of website header layouts essentially use the existing brannan event name + nav structure.
  // The V3+ following sets will be unique and not share the legacy structure.
  return websiteHeader ? (
    <>
      <HeaderPreloader />
      <HeaderV2
        {...restProps}
        websiteHeader={websiteHeader}
        pageId={pageId}
        masthead={masthead}
      />
    </>
  ) : (
    <Header
      {...restProps}
      eventDisplayName={eventDisplayName}
    />
  );
};

export default WebsiteHeader;
